/* eslint-disable no-underscore-dangle */
// Copyright (c) 2019 Deere & Company

import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './root-reducer';
import thunk from 'redux-thunk';

const initialState = {};

const enhancers = [];

const middleware = [thunk];

if (process.env.NODE_ENV === 'development') {

    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {

        enhancers.push(devToolsExtension());

    }

}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers,
);

let store;

export const getStore = () => {

    if (!store) {

        store = createStore(rootReducer(), initialState, composedEnhancers);

    }

    return store;

};
